import { defineEvent } from '../types/event';
export var CART_ADD_PDP = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Add_to_Cart_PDP'
        }
    ]
});
